const text = `[[topSection]]Your online privacy is very important to [[publisherName]]. We therefore want to inform you of the following:

We store information on your device to make this website function. Your device can also be accessed by [[thirdPartiesUrl]] for similar information storage.

Personal data, such as your IP address and unique user IDs, can be used by us and [[thirdPartiesUrl]] for the following purposes, for which [[thirdPartiesUrl]] may request your consent:
[[purposes]]

Purposes for which [[thirdPartiesUrl]] claim legitimate interest without the right to object:
[[legitimateInterest]]

And features for which [[thirdPartiesUrl]] explicitly require your opt-in: 
[[features]]

We provide this interface to give you control over your privacy settings. You can change your privacy settings at any time while visiting our website. To open this dialog window, please navigate to the Privacy button on your screen. 

Besides asking for your consent, [[thirdPartiesUrl]] may claim [[legitimateInterestUrl]] as a legal basis for processing personal data. In most cases, you have a right to object to this. A signal to relay your objection to a 'third party' is managed by this privacy manager.

We and [[totalVendors]] other [[partnersScreen]] members may, upon full acceptance, store and/or access information on your device for personalized advertising and content.

Withholding consent can lead to more ads, and ads not suited to your interests.

Any consent, objection or opt-in you provide, is limited in scope to this website.

[[bottomSection]]
`;
export default text;